import { mapActions, mapGetters } from "vuex";
import * as actions from "../../../../store/modules/actions"
import * as getters from "../../../../store/modules/getters"
import { Notification } from  "element-ui"
import CustomHostNames from "../../CustomHostNames/CustomHostNames.vue";
import { cvtRouteNodes } from '@/js/utils/routes'

export default {
  name: "ConfigDns",
  components: {
    CustomHostNames
  },
  props: {},
  data() {
    return {
      loading: false,
      customHostNames: [],
    }
  },
  computed: {
    ...mapGetters({
      dnsConfig: getters.CUSTOM_HOST_NAMES
    })
  },
  methods: {
    ...mapActions({
      loadCustomHostNames: actions.LOAD_CUSTOM_HOST_NAMES,
      verifyHostNames: actions.VERIFY_CUSTOM_HOST_NAMES
    }),
    async verifyCustomHostnames(): void {
      try{
        this.loading = true
        await this.verifyHostNames()

        Notification.success({
          title: 'Success',
          message: 'Custom Host Name Verified',
          position: 'bottom-right'
        })

        this.$router.push({
          name: cvtRouteNodes.enterpriseIntegrateBuilderVerifyHostname
        });
      }
      catch(e){
        Notification.error({
          title: 'Woops',
          message: 'Error Verifying Custom Host Name',
          position: 'bottom-right'
        })
      }
      finally{
        this.loading = false
      }
    }
  },
  async created() {
    await this.loadCustomHostNames()
    this.customHostNames = this.dnsConfig.hostnames
  }
}
